import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=178f7a3c&scoped=true"
import script from "./recycleBin.vue?vue&type=script&lang=js"
export * from "./recycleBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f7a3c",
  null
  
)

export default component.exports